export function navigateToExternalUrl(url: string): void {
  window.location.assign(url);
}
